import { apiFetch } from '@shared/api/http'
import { SubscriptionSchema } from './subscription.contract'
import type { Subscription } from './subscription.contract'

export async function cancelSubscription(
  subscriptionId: string,
  atPeriodEnd = true,
): Promise<Subscription> {
  return SubscriptionSchema.parse(
    await apiFetch<unknown>(`/recurrence/subscriptions/${subscriptionId}/cancel`, {
      method: 'POST',
      body: { atPeriodEnd },
    }),
  )
}

export async function retrySubscription(subscriptionId: string): Promise<Subscription> {
  return SubscriptionSchema.parse(
    await apiFetch<unknown>(`/recurrence/subscriptions/${subscriptionId}/retry`, {
      method: 'POST',
    }),
  )
}
